import _ from "lodash";
import moment from 'moment';

export const dateToString = (date) => {
  let day = date.getDate(),
    month = date.getMonth() + 1,
    year = date.getFullYear();

  if (day < 10) day = `0${day}`;
  if (month < 10) month = `0${month}`;

  return `${year}-${month}-${day}`;
}

export const backMonths = (n = 0, date = new Date()) => {
  return new Date(date.setMonth(date.getMonth() - n));
}

export const createLocalFromISOString = (isoString = '') => {
    if (!isoString) return null;

  // Extract the datetime part (ignore timezone/offset)
  const match = isoString.match(/^\d{4}-\d{2}-\d{2}T?\d{0,2}:?\d{0,2}:?\d{0,2}/);
  if (!match) return new Date(isoString);

  return new Date(match[0]);
}

export const displayDate = (date = new Date(), format = 'd/m/y', preserveIsoDate = false) => {
  if (!date) return '';

  if(typeof date === 'string') {
    date = preserveIsoDate ? createLocalFromISOString(date) : new Date(date);
  }

  let day = date.getDate(),
    month = date.getMonth() + 1,
    year = date.getFullYear();

  if (day < 10) day = `0${day}`;
  if (month < 10) month = `0${month}`;

  let dateFormated = format.replace('d', day);
  dateFormated = dateFormated.replace('m', month);
  dateFormated = dateFormated.replace('y', year);

  return dateFormated;
}

export const dateToMonthYear = (date) => {
  const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Set',
    'Oct',
    'Nov',
    'Dec'
  ];

  return `${month[date.getMonth()]} ${date.getDate()}`;
}

export const addZeroToTime = (i) => {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}

export function formatRelativeTimeAgo(value, labels = {}) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const m = moment.utc(value);

  if (!m.isValid()) {
    return '';
  }

  const justNow = labels.justNow || 'just now';
  const fewMinutesAgo = labels.fewMinutesAgo || 'a few minutes ago';
  const secondsAgo = Math.max(0, moment.utc().diff(m, 'seconds'));

  if (secondsAgo <= 5 * 60) {
    return justNow;
  }

  if (secondsAgo < 60 * 60) {
    return fewMinutesAgo;
  }

  return m.local().fromNow();
}

const getQueryDefaultDateRange = () => {
  const dateFrom = moment(new Date()).add(-8, 'days').format("YYYY-MM-DD");
  const dateTo = moment(new Date()).format("YYYY-MM-DD");
  return [dateFrom, dateTo];
}

export default {
  dateToMonthYear,
  dateToString,
  displayDate,
  formatRelativeTimeAgo,
  getQueryDefaultDateRange
}